<template>
    <div class="rightContent">
        <!-- 头部 -->
        <v-header v-bind="$attrs" />
        <!-- 内容区 -->
        <div class="content">
            <!-- form -->
            <FormContent
                v-bind="$attrs"
                :funcType.sync="funcType"
                :pmObj="pmObj"
                :mapObj="mapObj"
                :treeObj="treeObj"
                @refresh-content="onRefresh"
            />

            <!-- 内容展示区 如果是组织单元  则不存在内容展示区 默认不展示-->
            <PmContent
                v-if="funcType === 1"
                :pmObj.sync="pmObj"
                :carrierArray="carrierArray"
                :carrierScene="carrierScene"
                :deviceScene="deviceScene"
                :treeObj="treeObj"
            />
            <MapContent v-if="funcType === 2" :mapObj="mapObj" :carrierScene="carrierScene" :treeObj="treeObj" />
        </div>
    </div>
</template>

<script>
import Header from './Header.vue';
import FormContent from './FormContent.vue';
import MapContent from './MapContent-mf-new.vue';
import PmContent from './PmContent-mf.vue';

import bus from '@/utils/bus.js';
import {
    sceneGetMapDetail,
    sceneGetPlanDetail,
    carrierGetCarrierBySceneId,
    getBindDevicePosition,
    getUnBindDevicePosition
} from '@/api/modules/architecture.js';
import { CARRIER_TYPE_ICON_FN, DEVICE_TYPE_ICON_FN } from '@/utils/iconMatch.js'

import { shareParam } from '@/api/modules/public.js';
import { deviceType } from '@/utils/icon'
import { handlePlanData, PLAN_INFO_TYPE } from '@/utils/planUtil-mf'

export default {
    components: {
        'v-header': Header,
        FormContent,
        MapContent,
        PmContent
    },
    data() {
        return {
            mapObj: {}, //地图数据
            pmObj: {}, //平面图数据
            carrierArray: [], //监测点状态
            stautsIconArray: [
                //监测点状态
                'iconfont icon-yunhang',
                'iconfont icon-beiyong',
                'iconfont icon-baofei',
                'iconfont icon-daixiugai',
                'iconfont icon-chushuang'
            ],
            // 监测点类型
            carrierIconArray: [
                {
                    type: 1,
                    icon: 'iconfont icon-weibolu-xian'
                },
                {
                    type: 2,
                    icon: 'iconfont icon-bingxiang'
                },
                {
                    type: 3,
                    icon: 'iconfont icon-9lengku'
                },
                {
                    type: 4,
                    icon: 'iconfont icon-9lengku'
                }
            ],
            // 架构关联的监测点
            carrierScene: [],
            deviceScene: [],
            treeObj: {}, // 点击树形数据
            funcType: null,
            refreshKey: 0
        };
    },
    watch: {
        treeObj: {
            handler(newVal) {
                if (newVal) {
                    if (newVal.funcType === 3) {
                        this.funcType = 1;
                    } else {
                        this.funcType = newVal.funcType;
                    }
                }
            },
            deep: true
        },
        funcType: {
            handler(newVal) {
                if (newVal === 1) {

                } else if (newVal === 2) {

                }

            },
        },
    },
    computed: {

    },
    mounted() {
        this.getNodeClickTreeFn();
    },
    beforeDestroy() {
        bus.$off('nodeClickTree');
    },
    methods: {
        //树节点功能类型，0-单元节点，1-平面图节点，2-地图节点
        getNodeClickTreeFn() {
            bus.$on('nodeClickTree', row => {
                this.treeObj = { ...row };
                if (row.funcType === 1 || row.funcType === 2 || row.funcType === 3) {
                    this.getPmContent(row);
                    this.getMapContent({ sceneId: row.sceneId });
                    this.getCarrierData({ sceneId: row.sceneId });
                }
            });
        },
        getMapContent(obj) {
            sceneGetMapDetail(obj).then(({ result }) => {
                if (result?.mapId) {
                    this.mapObj = result;
                }else {
                  this.mapObj = null;
                }
            });
        },
        async getPmContent(row) {
            const res1 = await sceneGetPlanDetail({ sceneId: row.sceneId })
            if (res1?.result?.planId) {
                const res2 = await getBindDevicePosition(res1.result.planId)
                this.pmObj = res1.result;
                this.pmObj.devicePositionList = res2.result

                this.pmObj.carrierPositionList = this.pmObj.carrierPositionList.map(item => handlePlanData(item, PLAN_INFO_TYPE.CARRIER))

                this.pmObj.devicePositionList = this.pmObj.devicePositionList.map(item => handlePlanData(item, PLAN_INFO_TYPE.DEVICE))

                await this.getDeviceData({ planId: this.pmObj.planId, sceneId: row.sceneId })
            }else {
              this.pmObj = null;
            }
        },
        getCarrierData(obj) {
            carrierGetCarrierBySceneId(obj).then(({ result }) => {
                // this.carrierScene = CARRIER_TYPE_ICON_FN(result, 'typeId');
                this.carrierScene = result
            });
        },
        async getDeviceData(obj) {
            const res = await getUnBindDevicePosition(obj)
            this.deviceScene = res.result
        },
        getCarrierStatus() {
            shareParam({ code: 'carrier_status_item', type: 0 }).then(({ result }) => {
                result.forEach((item, index) => {
                    item.icon = this.stautsIconArray[index];
                });
                this.carrierArray = result;
            });
        },
        onRefresh(funcType) {
            if (funcType === 1) {
                // 重新拉地图
                this.getMapContent({ sceneId: this.treeObj.sceneId })
            } else {
                // 重新拉平面图
                this.getPmContent(this.treeObj)
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.rightContent {
    height: 100%;
    flex: 1;
    background-color: #fff;
    //border-left: 1px solid $borderColor3;
    box-sizing: border-box;

    .content {
        height: calc(100% - 50px);
        padding: 10px;
        box-sizing: border-box;
    }
}
</style>
